import React, { useContext } from 'react';
import ThemeContext from '../../../../setup/themeContext';
import classes from './ThemeBox.module.scss';
import { useThemeMode } from 'setup/themeContextMaterial';

function ThemeBox() {
  // const [theme, setTheme] = useState("light");
  const themeCtx = useContext(ThemeContext);
  const { toggleTheme, mode } = useThemeMode();
  let theme = themeCtx.theme;
  return (
    <div
      className={classes.themeBox}
      onClick={() => {
        themeCtx.toggleTheme();
        toggleTheme();
      }}
    >
      <div className={`${classes.toggle} ${theme === 'dark' ? classes.darkMode : ''}`}></div>
    </div>
  );
}

export default ThemeBox;
